import { useQuery } from '@tanstack/react-query'
import { getKemCard } from '../walletServices'
import { GetKemCardParams } from '../walletTypes'

interface UseGetKemCardParams extends GetKemCardParams {
  enabled?: boolean
  toggleCount?: number
}

export const useGetKemCard = (params: UseGetKemCardParams) => {
  const isEnabled =
    params.enabled === true && !!params.cardId && params.cardId !== ''

  return useQuery({
    queryKey: ['kem-card-details', params.cardId, params.toggleCount || 0], // Use toggle count to force refetch
    queryFn: () => getKemCard(params),
    staleTime: 0, // Data is immediately stale
    gcTime: 0, // Don't keep in cache (formerly cacheTime)
    enabled: isEnabled,
  })
}
